import React, { useState, FormEvent } from 'react';
import { IVisitorQuestionnaireSectionStepProps } from './types';
import VisitorQuestion from './VisitorQuestion';
import { StepperButtons } from '../../../stepper/buttons';
import { Alert } from 'react-bootstrap';
import useStepper from '../../../stepper/useStepper';

const VisitorQuestionnaireSectionStep: React.FC<IVisitorQuestionnaireSectionStepProps> = ({
  questions,
  onAnswer,
}) => {
  const { hasNext, showNext, onFinish } = useStepper();

  const [showErrors, setShowErrors] = useState<boolean>(false);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (questions.every((question) => question.answer)) {
      setShowErrors(false);
      hasNext ? showNext() : onFinish();
    } else {
      setShowErrors(true);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {showErrors && (
        <Alert variant="danger">
          <Alert.Heading>Unanswered Question</Alert.Heading>
          Please ensure that you have answered all the questions before
          proceeding
        </Alert>
      )}
      {questions.map((question) => (
        <VisitorQuestion
          key={question.id}
          answer={question.answer}
          yesMessage={question.yesMessage}
          noMessage={question.noMessage}
          onAnswer={(value) => onAnswer(question.id, value)}
        >
          {question.text}
        </VisitorQuestion>
      ))}
      <div className="mt-4 text-right">
        <StepperButtons submitMode finishLabel="Sign In" />
      </div>
    </form>
  );
};

export default VisitorQuestionnaireSectionStep;
